import AddArticle from './AddArticle';

export default AddArticle;
